import styled from 'styled-components';
import { px } from '../../../../../../contrib/ui';

export const TeamsCreatorPlayerSelectorStyled = styled.div`
  .full-team-chip {
    width: 100%;
  }
  .input-form-control {
    width: 100%;
  }
  .list {
    padding: 0;

    .list-body {
      height: ${px(600)};
      overflow-y: scroll;
      margin: 0 -10px;
      padding: 10px 10px;
    }
  }
`;
